module.exports = __webpack_public_path__ + "static/media/support_logo.32981b3f.png";